import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import SynthesiaImage from '../../../../assets/newImages/synthesia.jpg'
import ytPlayBtn from '../../../../assets/newImages/Play.svg';
import { Calendar } from '../../../../components/Icons/Icons';
import ModalPlayer from '../../../../components/PlayerModal/playerModal';
import { formatDate, getPlainTextFromWYSIWYG, sortDataByOrder } from "../../../../utils/helper";
import './CardList.scss';
import { getYouTubeVideoId } from '../../../../utils/helper';

const CardList = ({
  responseData,
  color,
  PlayVideoHandler,
  convertToStandardURL,
  isModalOpen,
  handleCancel,
  videoUrl,
  mediaType,
  onCardClickHandler,
  levels,
  levelIndexMap,
  levelColor,
  sort=true
}) => {

  const [cardsData, setCardsData] = useState([]);

  const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });
  const extractSynthesiaId = (url) => {
    const match = url.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
    return match ? match[0] : null;
  };

  const level = levels?.find((level) =>
    responseData.some((data) => data.levelId === level.id)
  );

  const getLevelColor = (levelId) => {
    const level = levels.find((level) => level.id === levelId);
    return level ? levelColor[levelIndexMap[level.value]] : "transparent";
  };

  function replaceUnderscoreWithSpace(str) {
    return str?.replace(/_/g, ' ')?.toLowerCase();
  }

  useEffect(() => {
    if(responseData?.length > 0 ){
      setCardsData( sort ?sortDataByOrder(responseData) : responseData);
    }
  }, [responseData]);

  const renderDescription = (data) => {
    if (data?.type) {
      switch (data.type) {
        case "PRESS":
        case "NEWS_TAB":
          return (
            <>
              <p className="news-card-description">
                {getPlainTextFromWYSIWYG(data.description)}
              </p>
              <span className="news-card-date">
                <Calendar />
                {formatDate(data.createdAt)}
              </span>
            </>
          );
        default:
          return (
            <p
              className={`card-description ${data?.experienceOfWorkOpportunityOutput?.opportunityType
                ? "experience-of-work"
                : ""
                }`}
            >
              {data.description ||
                replaceUnderscoreWithSpace(data?.experienceOfWorkOpportunityOutput?.opportunityType)}
            </p>
          );
      }
    }
    return (
      <>
        <p
          className={`card-description hello ${data?.experienceOfWorkOpportunityOutput?.opportunityType
            ? "experience-of-work"
            : ""
            }`}
        >
          {data.description ||
            replaceUnderscoreWithSpace(data?.experienceOfWorkOpportunityOutput?.opportunityType)}
        </p>
        <p className={"card-description"} style={{ marginTop: "10px" }}>
          {data?.experienceOfWorkOpportunityOutput?.description &&
            data?.experienceOfWorkOpportunityOutput?.description}
        </p>
      </>
    );
  };
  return (
    <div className="card-list-container">
      <div className="card-container">
        {cardsData && cardsData?.length > 0 ? (
          cardsData?.map((data, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
              }}
              className="card-item cardlist"
            >

              {isSmallScreen && (
                <div
                  className={`${level ? "card-title with-level" : "card-title"} desktopView`}
                  title={data?.title ||
                    data?.subTitle ||
                    data.experienceOfWorkTitle}
                  style={{
                    display: level && "flex",
                    alignItems: level && "center",
                    // marginLeft: level ? "-8px" : "0px",
                    WebkitLineClamp: data.type === "PRESS" ? "2" : "1",
                    marginLeft: isSmallScreen ? '6px' : '0'
                  }}
                >
                  {level && (
                    <div
                      style={{
                        width: isSmallScreen ? "10px" : "15px",
                        height: isSmallScreen ? "10px" : "15px",
                        borderRadius: "50%",
                        backgroundColor:
                          getLevelColor(data.levelId) || "transparent",
                        marginRight: "8px",
                        marginLeft: '0px',
                      }}
                    ></div>
                  )}
                  {data.title === "WhyDo"
                    ? "Why we exist"
                    : data.title === "whatDo"
                      ? "What  we do"
                      : data.title === "howDo"
                        ? "How we help clients"
                        : data?.title ||
                        data?.subTitle ||
                        data.experienceOfWorkTitle ||
                        "Story"}
                </div>
              )}

              <div
                className="text-container"
                onClick={() => {
                  onCardClickHandler(data);
                }}
              >
                {!isSmallScreen && (
                <div
                  className={`${level ? "card-title with-level" : "card-title"} desktopView`}
                  title={data?.title ||
                    data?.subTitle ||
                    data.experienceOfWorkTitle}
                  style={{
                    display: level && "flex",
                    alignItems: level && "center",
                    // marginLeft: level ? "-8px" : "0px",
                    WebkitLineClamp: data.type === "PRESS" ? "2" : "1",
                    marginLeft: isSmallScreen ? '6px' : '0'
                  }}
                >
                  {level && (
                    <div
                      style={{
                        width: isSmallScreen ? "10px" : "15px",
                        height: isSmallScreen ? "10px" : "15px",
                        borderRadius: "50%",
                        backgroundColor:
                          getLevelColor(data.levelId) || "transparent",
                        marginRight: "8px",
                        marginLeft: '0px',
                      }}
                    ></div>
                  )}
                  {data.title === "WhyDo"
                    ? "Why we exist"
                    : data.title === "whatDo"
                      ? "What  we do"
                      : data.title === "howDo"
                        ? "How we help clients"
                        : data?.title ||
                        data?.subTitle ||
                        data.experienceOfWorkTitle ||
                        "Story"}
                </div>
                )}
                <>
                  {renderDescription(data)}
                </>
              </div>

              <div
                className="color-band"
                style={{ backgroundColor: color[i % color?.length] }}
              />

              <div className='image-container'>
                {data?.mediaLink ? <>
                  {data?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
                    data?.mediaLink?.url ? (
                    (() => {
                      const videoID = getYouTubeVideoId(data.mediaLink.url);
                      if (!videoID) return null;

                      return (
                        <div
                          className="media vimeo youtube"
                          onClick={() =>
                            PlayVideoHandler(
                              `https://www.youtube.com/embed/${videoID}?autoplay=1&rel=0`,
                              data.mediaLink.mediaType
                            )
                          }
                        >
                          <div style={{ position: "relative" }}>
                            <img
                              src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                              alt="YouTube Video"
                              className="vimeo-video-preview-image video-preview-image"
                            />
                            <img
                              className="ytBtnOverlay"
                              src={ytPlayBtn}
                              alt="Play Button"
                            />
                          </div>
                        </div>
                      );
                    })()
                  )

                    : data?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
                      data?.mediaLink?.url ? (
                      <div
                        className="media vimeo youtube"
                        onClick={() =>
                          PlayVideoHandler(
                            data?.mediaLink?.url,
                            data?.mediaLink?.mediaType
                          )
                        }
                      >
                        <img
                          src={`https://vumbnail.com/${data?.mediaLink?.url?.split("/")[4]
                            }.jpg`}
                          className="vimeo-video-preview-image video-preview-image"
                          alt="Vimeo Preview"
                        />
                        <img
                          className="ytBtnOverlay"
                          src={ytPlayBtn}
                          alt="Play Button"
                        />
                      </div>


                    ) :
                      data?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
                        data?.mediaLink?.url ? (
                        (() => {
                          const videoId = extractSynthesiaId(data.mediaLink.url);
                          if (!videoId) return null;


                          return (
                            <div
                              className="media vimeo youtube"
                              onClick={() =>
                                PlayVideoHandler(
                                  `https://share.synthesia.io/embeds/videos/${videoId}?autoplay=1`,
                                  data.mediaLink.mediaType
                                )
                              }
                            >
                              <div style={{ position: "relative" }}>
                                {/* Use a placeholder thumbnail */}
                                <img
                                  src={data?.mediaLink?.thumbnailUrl || SynthesiaImage}
                                  alt="Synthesia Video"
                                  className="vimeo-video-preview-image video-preview-image"
                                />
                                <img
                                  className="ytBtnOverlay"
                                  src={ytPlayBtn}
                                  alt="Play Button"
                                />
                              </div>
                            </div>
                          );
                        })()
                      )

                        :


                        (
                          <div
                            className="media"
                            onClick={() => {
                              if (data?.webLink) {
                                window.open(data?.webLink, "_blank");
                              }
                            }}
                          >
                            {data?.mediaLink?.url && (
                              <div className="slider-Img">
                                <img
                                  src={data.mediaLink.url}
                                  alt=""
                                  className="home-preview-img"
                                  title=""
                                />
                              </div>
                            )}

                          </div>
                        )}

                </>

                  :
                  <div className="media">

                    <div className="slider-Img">
                      {/* <img
                        src={DefaultThumbnail_16X9}
                        alt="Preview"
                        className="home-preview-img"
                        title=''
                      /> */}
                    </div>
                  </div>

                }

              </div>
            </motion.div>
          ))
        ) : (
          <div className="info-container">
            Nothing here at the moment!
          </div>
        )}
      </div>
      {isModalOpen ? (
        <ModalPlayer
          closeModal={handleCancel}
          mediaLink={videoUrl}
          mediaType={mediaType}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default CardList;
